import React from 'react';
import { useTranslation } from 'react-i18next';

const Footer = () => {
  const { t } = useTranslation();
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-[#0f1729] text-gray-100 py-12 px-4 sm:px-6 lg:px-8">
      <div className="max-w-7xl mx-auto">
        {/* Main footer content */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 lg:gap-12">
          {/* Company Info */}
          <div className="space-y-4">
            <h3 className="text-2xl lg:text-3xl font-bold text-[#b4a35e]">APED</h3>
            <p className="text-sm lg:text-base leading-relaxed max-w-xs text-gray-300">
              {t('footer.tagline')}
            </p>
          </div>

          {/* Quick Links */}
          <div className="space-y-4">
            <h4 className="text-lg lg:text-xl font-semibold text-[#b4a35e]">
              {t('footer.quickLinks')}
            </h4>
            <nav>
              <ul className="space-y-2 lg:space-y-3">
                {[
                  ['home', '#hero'],
                  ['about', '#about'],
                  ['visionMission', '#vision-mission'],
                  ['values', '#services'],
                  ['projects', '#why-invest'],
                  ['contact', '#contact'],
                ].map(([key, href]) => (
                  <li key={key}>
                    <a
                      href={href}
                      className="text-sm lg:text-base text-gray-300 hover:text-[#b4a35e] transition-colors duration-300 block py-1"
                    >
                      {t(`navbar.${key}`)}
                    </a>
                  </li>
                ))}
              </ul>
            </nav>
          </div>

          {/* Contact Info */}
          <div className="space-y-4">
            <h4 className="text-lg lg:text-xl font-semibold text-[#b4a35e]">
              {t('footer.contact')}
            </h4>
            <address className="not-italic space-y-3">
              <p className="text-sm lg:text-base leading-relaxed text-gray-300">{t('footer.address')}</p>
              <div className="space-y-2">
                <p className="text-sm lg:text-base">
                  <span className="text-gray-300">{t('footer.phone')}: </span>
                  <a
                    href="tel:+237670554129"
                    className="text-gray-300 hover:text-[#b4a35e] transition-colors duration-300"
                  >
                    +237 670 554 129
                  </a>
                </p>
                <p className="text-sm lg:text-base">
                  <span className="text-gray-300">{t('footer.phone')}: </span>
                  <a
                    href="tel:+237699648403"
                    className="text-gray-300 hover:text-[#b4a35e] transition-colors duration-300"
                  >
                    +237 699 648 403
                  </a>
                </p>
              </div>
            </address>
          </div>
        </div>

        {/* Footer Bottom */}
        <div className="mt-12 pt-8 border-t border-gray-700 text-center">
          <p className="text-xs lg:text-sm text-gray-400">
            &copy; {currentYear} APED. {t('footer.allRightsReserved')}
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;